import MediaGallery from 'js/components/MediaGallery';

Drupal.behaviors.mediaGallery = {
  attach: (context) => {
    context.querySelectorAll('.paragraph--media-gallery').forEach((element) => {
      if (!element.MediaGallery) {
        element.MediaGallery = new MediaGallery(element);
      }
    });
  },
};
